/* PerriPaws predictive search (Shopify Predictive Search API) */
(function () {
  'use strict';
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(form) {
    if (form._ppReady) return;
    form._ppReady = true;
    var input = qs('[data-pp-predictive-input]', form);
    var results = qs('[data-pp-predictive-results]', form);
    var clear = qs('[data-pp-search-clear]', form);
    var timer, controller, activeIndex = -1;
    var url = (window.PerriPaws && window.PerriPaws.routes.predictiveSearch) || '/search/suggest';

    function close() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    }
    function open() {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function options() { return qsa('[role="option"]', results); }
    function highlight(i) {
      var opts = options();
      opts.forEach(function (o, idx) { o.setAttribute('aria-selected', idx === i ? 'true' : 'false'); });
      activeIndex = i;
      if (opts[i]) { input.setAttribute('aria-activedescendant', opts[i].id); opts[i].scrollIntoView({ block: 'nearest' }); }
    }

    function fetchResults(term) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      results.innerHTML = '<p class="pp-pred__title">Searching…</p>';
      open();
      fetch(url + '?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=4&resources[options][unavailable_products]=last&section_id=pp-predictive-search', controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = qs('[data-pp-pred-source]', doc);
          if (!src || !input.value.trim()) { close(); return; }
          results.innerHTML = src.innerHTML;
          activeIndex = -1;
          open();
        })
        .catch(function (err) { if (err.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (clear) clear.hidden = !input.value;
      clearTimeout(timer);
      if (!term) { close(); return; }
      timer = setTimeout(function () { fetchResults(term); }, 220);
    });
    input.addEventListener('focus', function () { if (input.value.trim() && results.innerHTML) open(); });
    input.addEventListener('keydown', function (e) {
      var opts = options();
      if (e.key === 'ArrowDown' && !results.hidden) { e.preventDefault(); highlight(Math.min(activeIndex + 1, opts.length - 1)); }
      else if (e.key === 'ArrowUp' && !results.hidden) { e.preventDefault(); highlight(Math.max(activeIndex - 1, 0)); }
      else if (e.key === 'Enter' && activeIndex > -1 && opts[activeIndex]) { e.preventDefault(); window.location.href = opts[activeIndex].href; }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    if (clear) clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; close(); input.focus(); });
  }

  function boot() { qsa('[data-pp-predictive]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* The search overlay is an ordinary .pp-drawer, so perripaws.js already handles opening it,
     the body lock, Escape and returning focus to whatever opened it. The one thing it cannot
     know is that this drawer wants the text field focused rather than its close button, so the
     field is claimed here on the drawer's own open event. Re-running boot() first covers a
     drawer whose markup arrived after load, for example a theme-editor section re-render. */
  document.addEventListener('pp:drawer:open', function (e) {
    var drawer = e.target;
    if (!drawer || !drawer.querySelector) return;
    var field = drawer.querySelector('[data-pp-search-autofocus]');
    if (!field) return;
    boot();
    window.setTimeout(function () {
      try { field.focus({ preventScroll: true }); } catch (err) { field.focus(); }
      field.select();
    }, 90);
  });

  /* Leaving a stale term and its suggestions behind means reopening search shows the previous
     search. Cleared on close, which also collapses the listbox through the input event. */
  document.addEventListener('pp:drawer:close', function (e) {
    var drawer = e.target;
    if (!drawer || !drawer.querySelector) return;
    var field = drawer.querySelector('[data-pp-search-autofocus]');
    if (!field || !field.value) return;
    field.value = '';
    field.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
